export default __webpack_public_path__ + "static/media/e.b74b8efa.svg";